import * as api from 'api/methods';

type PreviewPayload = {
  err?: unknown;
  images?: Record<string, unknown>;
};

export const getFramesPreviews = async ({
  layers,
  fileId,
}: {
  layers: { id: string }[];
  fileId: string;
}) => {
  const promises = layers.map((layer: any) =>
    api
      .getFigmaNodePreview({ fileId, nodeId: layer.id, format: 'jpg' })
      .then((previewData: any) => {
        const p = previewData as PreviewPayload;
        if (p.err) {
          return null;
        }

        return p.images ?? null;
      }),
  );

  const previews = await Promise.all(promises);

  return Object.assign({}, ...previews.filter(Boolean));
};
